<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="none" name="plantCd" v-model="searchParam.plantCd" @input="getList"/>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :required="true"
            type="year"
            default="today"
            label="기준년도"
            name="wasteYear"
            @input="getList"
            v-model="searchParam.wasteYear"
          />
        </div>
      </template>
    </c-search-box>
    <div class="col-12" style="background:#fff;">
      <apexchart 
        ref="chart1" 
        height="300" 
        type="line"
        :width="chart.chartWidth"
        :options="chart.chartOptions" 
        :series="chart.series"></apexchart>
    </div>
    <br>
    <div class="col-12" style="background:#fff;">
      <apexchart 
        ref="chart2" 
        height="300" 
        type="line"
        :width="chart2.chartWidth"
        :options="chart2.chartOptions" 
        :series="chart2.series"></apexchart>
    </div>
    <br>
    <div class="col-12" style="background:#fff;">
      <apexchart 
        ref="chart3" 
        height="300" 
        type="line"
        :width="chart3.chartWidth"
        :options="chart3.chartOptions" 
        :series="chart3.series"></apexchart>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import VueApexCharts from "vue-apexcharts";
export default {
  name: 'waste-uc-graph',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          mainPeriod: '',
          mainPlantCd: null,
        }
      },
    },
  },
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      searchParam: {
        wasteYear: '',
        plantCd: null,
      },
      chart: {
        chartOptions: {
          title: {
            text: '폐기물발생량(Kg) / 생산량(Ton) 원단위 추이 분석'
          },
          colors: ['#008FFB','#00E396','#FEB019','#FF4560','#775DD0','#1DDB16','#00D8FF','#4CAF50','#F9CE1D','#FF9800','#A300D6','#5653FE','#1B998B','#F86624','#13D8AA'],
          chart: {
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            toolbar: {
              show: true
            },
            zoom: {
              enabled: false
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
          },
          xaxis: {
            categories: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          yaxis: {
            title: {
              text: '원단위분석'
            }
          },
          /* eslint-disable no-unused-vars */
          // tooltip: {
          //   custom: function({ series, seriesIndex, dataPointIndex, w }) {
          //     return (
          //       JSON.stringify(w.globals.categoryLabels[dataPointIndex]) +

          //       "</span>" +
          //       "</div>"
          //     );
          //   }
          // },
          fill: {
            opacity: 1
          },
          markers: {
            size: 1,
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center',
          }
        },
        series: [],
        chartWidth: '100%',
      },
      chart2: {
        chartOptions: {
          title: {
            text: '폐기물처리비용(원) / 생산량(Kg) 원단위 추이 분석'
          },
          chart: {
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            toolbar: {
              show: true
            },
            zoom: {
              enabled: false
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
          },
          xaxis: {
            categories: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          yaxis: {
            title: {
              text: '원단위분석'
            }
          },
          fill: {
            opacity: 1
          },
          markers: {
            size: 1,
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            // formatter: function(label, opts) {
            //   return label + " - " + opts.w.globals.series[opts.seriesIndex]
            // }
          }
        },
        series: [],
        chartWidth: '100%',
      },
      chart3: {
        chartOptions: {
          title: {
            text: '폐기물매각수익(원) / 생산량(Kg) 원단위 추이 분석'
          },
          chart: {
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            toolbar: {
              show: true
            },
            zoom: {
              enabled: false
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
          },
          xaxis: {
            categories: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          yaxis: {
            title: {
              text: '원단위분석'
            }
          },
          fill: {
            opacity: 1
          },
          markers: {
            size: 1,
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            // formatter: function(label, opts) {
            //   return label + " - " + opts.w.globals.series[opts.seriesIndex]
            // }
          }
        },
        series: [],
        chartWidth: '100%',
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // 메인에서 호출한 팝업파라미터
      if (this.popupParam.mainPlantCd) {
        this.searchParam.plantCd = (!this.popupParam.mainPlantCd || this.popupParam.mainPlantCd.length > 3 ? null : this.popupParam.mainPlantCd);
      } 
      if (this.popupParam.mainPeriod) {
        this.searchParam.wasteYear = this.popupParam.mainPeriod;
      }
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.waste.volume.uc.url;
      this.getList();
    },
    getList() {
      let isAllSearch = false;
      if (this.searchParam.plantCd.split(',').length > 1) {
        isAllSearch = true;
      }
      if (this.searchParam.wasteYear !== null) {
        this.$http.url = this.listUrl;
        this.$http.type = 'GET';
        this.$http.param = this.searchParam;
        this.$http.request((_result) => {
          if (isAllSearch) {
            // this.grid.data = this.$_.filter(_result.data, {tvTypeCdTop : 'A' });
            // this.grid2.data = this.$_.filter(_result.data, {tvTypeCdTop : 'F' });
            // this.grid3.data = this.$_.filter(_result.data, {tvTypeCdTop : 'O' });
            // this.grid4.data = this.$_.filter(_result.data, {tvTypeCdTop : 'J' });
            // this.grid5.data = this.$_.filter(_result.data, {tvTypeCdTop : 'Q' });
          } else {
            let sdata = this.$_.filter(_result.data, {tvTypeCdTop : 'O', totalFlag: 'X' });
            this.chart.series = [];
            this.$_.forEach(sdata, item => {
              this.chart.series.push({
                name:item.envWasteMstName,
                data: [item.tv01,item.tv02,item.tv03,item.tv04,item.tv05,item.tv06,item.tv07,item.tv08,item.tv09,item.tv10,item.tv11,item.tv12]
              })
            })
            
            let sdata2 = this.$_.filter(_result.data, {tvTypeCdTop : 'Q', totalFlag: 'X' });
            this.chart2.series = [];
            this.$_.forEach(sdata2, item => {
              this.chart2.series.push({
                name:item.envWasteMstName,
                data: [item.tv01,item.tv02,item.tv03,item.tv04,item.tv05,item.tv06,item.tv07,item.tv08,item.tv09,item.tv10,item.tv11,item.tv12]
              })
            })
            
            let sdata3 = this.$_.filter(_result.data, {tvTypeCdTop : 'X', totalFlag: 'X' });
            this.chart3.series = [];
            this.$_.forEach(sdata3, item => {
              this.chart3.series.push({
                name:item.envWasteMstName,
                data: [item.tv01,item.tv02,item.tv03,item.tv04,item.tv05,item.tv06,item.tv07,item.tv08,item.tv09,item.tv10,item.tv11,item.tv12]
              })
            })
          }
          this.$refs['chart1'].refresh();
          this.$refs['chart2'].refresh();
          this.$refs['chart3'].refresh();
        },);
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message:
          '기준년도를 선택하세요',
          type: 'warning', // success / info / warning / error
        });
      }
    },
  }
};
</script>
